"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { Poll } from "../ui/Poll";
import Button from "../ui/buttons";
import RadioField from "../ui/RadioField";
export default function PollForm() {
  const $ = _c(8);
  const [selected, setSelected] = useState("");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["\u0BAE\u0BC1\u0BB4\u0BC1\u0BAE\u0BC8\u0BAF\u0BBE\u0B95 \u0B92\u0BAA\u0BCD\u0BAA\u0BC1\u0B95\u0BCD\u0B95\u0BCA\u0BB3\u0BCD\u0B95\u0BBF\u0BB1\u0BC7\u0BA9\u0BCD", "\u0BAE\u0BC1\u0BB4\u0BC1\u0BAE\u0BC8\u0BAF\u0BBE\u0B95 \u0B89\u0B9F\u0BA9\u0BCD\u0BAA\u0B9F\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8", "\u0B92\u0BB0\u0BB3\u0BB5\u0BC1 \u0B92\u0BAA\u0BCD\u0BAA\u0BC1\u0B95\u0BCD\u0B95\u0BCA\u0BB3\u0BCD\u0B95\u0BBF\u0BB1\u0BC7\u0BA9\u0BCD", "\u0B92\u0BB0\u0BB3\u0BB5\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0B89\u0B9F\u0BA9\u0BCD\u0BAA\u0B9F\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const options = t0;
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className=" flex items-center  text-12-tamil-600 "><Poll id="1" label="Poll" bgColor="bg-EB5757" textColor="text-FFFFFF" /></div>;
    t2 = <p className="text-14-tamil-700 mt-3 leading-[1.5] line-clamp-2">கர்நாடக தேர்தலுக்கான ஆக்சிஸ் மை இந்தியா கருத்துக்கணிப்பு கணிப்பு. கர்நாடக தேர்தலுக்கான ஆக்சிஸ் மை இந்தியா கருத்துக்கணிப்பு கணிப்பு</p>;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== selected) {
    t3 = <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">{options.map((opt, index) => <RadioField key={index} label={opt} value={opt} checked={selected === opt} onChange={setSelected} className="px-4 py-3 w-full" />)}</div>;
    $[3] = selected;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Button variant="primary" onClick={_temp} className="w-full md:w-[116px] mt-4 text-14-tamil-700 text-012061 h-[40px] cursor-pointer">வாக்கு</Button>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3) {
    t5 = <div className="w-full max-w-[884px] min-h-[294px] p-5 bg-ECEEF3 mx-auto">{t1}{t2}{t3}{t4}</div>;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}
function _temp() {}